// 영수증·연산 id → 48비트 해시(base64url 8자, D10 저장 크기). 멱등 기억을 짧게 남길 때 쓴다(성장 원장 접기 legacy·장비 applied 압축).
// 순수 함수라 클라이언트·Worker 어디서나 같은 값이다(cyrb53 변형). 수천 개 안에서 우연히 겹칠 확률은 2^-48 단위라 무시한다.
const B64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';
export const ID_HASH_LEN = 8;
export function idHash48(id: string): string {
  let h1 = 0xdeadbeef, h2 = 0x41c6ce57;
  for (let i = 0; i < id.length; i++) {
    const c = id.charCodeAt(i);
    h1 = Math.imul(h1 ^ c, 2654435761);
    h2 = Math.imul(h2 ^ c, 1597334677);
  }
  h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^ Math.imul(h2 ^ (h2 >>> 13), 3266489909);
  h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^ Math.imul(h1 ^ (h1 >>> 13), 3266489909);
  const a = (h1 >>> 0) & 0xffffff, b = (h2 >>> 0) & 0xffffff;
  let s = '';
  for (let k = 18; k >= 0; k -= 6) s += B64[(a >>> k) & 63];
  for (let k = 18; k >= 0; k -= 6) s += B64[(b >>> k) & 63];
  return s;
}
